import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const ScreenShareIcon: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M23.334 1.334a7.334 7.334 0 1 0 0 14.667 7.334 7.334 0 0 0 0-14.667Zm-17.667 2c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3h5.667v3.333H9a1 1 0 1 0 0 2h3.17c.107.018.216.018.324 0h7.009c.107.018.217.018.324 0H23a1 1 0 1 0 0-2h-2.333v-3.333h5.667c1.654 0 3-1.346 3-3v-5.427a8.712 8.712 0 0 1-2 1.441v3.986c0 .551-.449 1-1 1H19.83a.997.997 0 0 0-.324 0h-7.01a.992.992 0 0 0-.325 0H5.667c-.551 0-1-.449-1-1v-14c0-.551.449-1 1-1h9.67a8.65 8.65 0 0 1 1.179-2H5.667Zm20.333 0a.666.666 0 0 1 .471 1.138l-2.195 2.195 2.196 2.196a.666.666 0 1 1-.943.942L22.862 7.14a.666.666 0 0 1 0-.943l2.667-2.667c.13-.13.3-.195.471-.195Zm-6 3.333c.171 0 .342.066.472.196l2.666 2.666c.261.261.261.682 0 .943l-2.666 2.667a.666.666 0 1 1-.943-.943l2.195-2.195-2.195-2.196A.666.666 0 0 1 20 6.667Zm-6.666 16.667h5.333v3.333h-5.333v-3.333Z"
    />
  </Icon>
);
